import { ComponentThemeType } from '@/cl/theme/theme.hooks';

export const DeliveryMethodCardTheme: ComponentThemeType = () => ({
  baseStyle: {
    container: {
      gridGap: 0,
    },
  },
});
